import { render } from "./RolesTable.vue?vue&type=template&id=7638262d&scoped=true"
import script from "./RolesTable.vue?vue&type=script&lang=js"
export * from "./RolesTable.vue?vue&type=script&lang=js"

import "./RolesTable.vue?vue&type=style&index=0&id=7638262d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7638262d"]])

export default __exports__